import { AccountPage } from "@src/deprecated/pages/Account";
export function meta() {
  return [
    { title: "Account" },
    { name: "description", content: "Account page" },
  ];
}

export default function Account() {
  return <AccountPage />;
}
